import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class CreditService {
  constructor(private http: HttpClient) { }

  public getCredit(): Observable<number> {
    return this.http.get<number>(`/user-settings/credit/current`);
  }
}
